// test2481
(2481 && 0);
